import Vue from 'vue'
import LocationsMap from './../modules/locations-map/LocationsMap.vue'
import 'whatwg-fetch'
import './index.css'
import i18n from './../i18n/Setup.js'

Vue.config.productionTip = false

new Vue({
  i18n,
  render: h => h(LocationsMap),
}).$mount('#locationsMap')
